import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";

// The search-input-with-icon pattern already established in LeadsBoard.jsx/KnowledgeBase.jsx,
// pulled out so every list/table/card view can reuse it instead of re-declaring the same
// relative+absolute icon positioning boilerplate.
export function SearchInput({ value, onChange, placeholder = "Search...", className = "w-64", testid }) {
  return (
    <div className={`relative ${className}`}>
      <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
      <Input data-testid={testid} placeholder={placeholder} value={value}
        onChange={(e) => onChange(e.target.value)} className="pl-9" />
    </div>
  );
}
